'use client';

import { Container } from '..';
import { useState } from 'react';
import type { FoodSummary } from 'lib/ogdb/types';
import { FoodListElement } from './FoodListElement';
import { foodHref } from './types';
import styles from './GlucoseResponse.module.css';

const cx = (...args: Array<string | false | undefined | null>) =>
  args.filter(Boolean).join(' ');

export const GlucoseResponse = ({
  className,
  topFoods,
  bottomFoods,
}: {
  className?: string;
  topFoods: FoodSummary[];
  bottomFoods: FoodSummary[];
}) => {
  const [activeTab, setActiveTab] = useState('top');

  const handletabClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    setActiveTab(e.currentTarget.value);
  };

  return (
    <section className={cx(styles.root, className)}>
      <Container className={styles.parentContainer}>
        <div className={styles.content}>
          {/* both zones render; CSS shows one per viewport (useWindowSize is 0 on SSR) */}
          <div className={styles.foodZones}>
            <div className={cx(styles.zone, 'top-zone')}>
              <h2>Top Zone</h2>
              <div className={styles.foodItems}>
                {topFoods.map((e, i) => {
                  return (
                    <FoodListElement
                      key={i}
                      food={e}
                      href={foodHref(e)}
                    />
                  );
                })}
              </div>
            </div>
            <div className={cx(styles.zone, 'bottom-zone')}>
              <h2>Bottom zone</h2>
              <div className={styles.foodItems}>
                {
                  // TODO
                  bottomFoods.map((e, i) => {
                    return (
                      <FoodListElement
                        key={i}
                        food={e}
                        href={foodHref(e)}
                      />
                    );
                  })
                }
              </div>
            </div>
          </div>
          <div className={styles.mobileFoodZones}>
            <p className={styles.tag}>See what&apos;s trending</p>
            <div className={styles.tabs}>
              <button
                onClick={(e) => handletabClick(e)}
                className={
                  activeTab === 'top' ? cx(styles.tab, styles.active) : styles.tab
                }
                value="top"
              >
                Top Zone
              </button>
              <button
                onClick={(e) => handletabClick(e)}
                className={
                  activeTab === 'bottom'
                    ? cx(styles.tab, styles.active)
                    : styles.tab
                }
                value="bottom"
              >
                Bottom Zone
              </button>
            </div>
            {activeTab === 'top' ? (
              <div className={cx(styles.zone, 'mobile-top-zone')}>
                <div className={styles.foodItems}>
                  {
                    // TODO
                    topFoods.map((e, i) => {
                      return (
                        <div key={i} className={styles.foodItemCard}>
                          <FoodListElement
                            key={i}
                            food={e}
                            href={foodHref(e)}
                          />
                        </div>
                      );
                    })
                  }
                </div>
              </div>
            ) : (
              <div className={cx(styles.zone, 'mobile-bottom-zone')}>
                <div className={styles.foodItems}>
                  {
                    // TODO
                    bottomFoods.map((e, i) => {
                      return (
                        <div key={i} className={styles.foodItemCard}>
                          <FoodListElement
                            key={i}
                            food={e}
                            href={foodHref(e)}
                          />
                        </div>
                      );
                    })
                  }
                </div>
              </div>
            )}
          </div>
        </div>
      </Container>
      {/* <div className="gradient-container" /> */}
    </section>
  );
};
